import { LANG_MAP, NEW_LANG_MAP } from "../GrammarModal";

export const isGrammarAvailable = (userLanguage) => [...Object.keys(LANG_MAP), ...Object.keys(NEW_LANG_MAP)].includes(userLanguage)
